import { ErrorCode } from '@constants/errorCodes';
import { ApiError } from '@types';

import { LeadType } from '../types/common';

export const META_SYNC_STATUS = {
  SYNCING: 'syncing',
  COMPLETED: 'completed',
  ERROR: 'error',
  PARTIAL_SUCCESS: 'partial_success'
} as const;

export const META_JOB_STATUS = {
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAILED: 'failed',
  PARTIAL_SUCCESS: 'partial_success'
} as const;

export type MetaSyncStatusValue =
  (typeof META_SYNC_STATUS)[keyof typeof META_SYNC_STATUS];

export const META_SYNC_TOAST_MESSAGES = {
  SUCCESS: 'Leads synced successfully from Meta.',
  ERROR: 'Failed to sync leads from Meta. Please try again.',
  PARTIAL_SUCCESS: 'Lead sync from Meta was incomplete. Please try again.'
} as const;

export const isMetaSyncedLead = (
  lead?: Pick<LeadType, 'is_external_synced'> | null
): boolean => Boolean(lead?.is_external_synced);

export const getMetaProviderErrorMessage = (error: any): string => {
  const apiError = error as ApiError;
  const errorCode = apiError?.data?.errorCode;

  switch (errorCode) {
    case ErrorCode.ERR_INVALID_ACCESS_TOKEN:
      return 'Invalid access token. Please enter a valid token to continue.';
    case ErrorCode.ERR_MISSING_PERMISSIONS:
      return 'This access token does not have the required permissions.';
    default:
      return apiError?.data?.message || 'Failed to configure Meta integration.';
  }
};
